import React from "react";
import {Button, Checkbox, Col, Dropdown, Menu, Modal, Popover, Row} from "antd";
import {EditOutlined, EllipsisOutlined, FileTextOutlined, WarningOutlined} from "@ant-design/icons";
import {formatDateShort, formatGrade, formatMoney, formatPercent} from "@lib/format";
import {DiamondIcon, FlameIcon, StorageBoxOutlineIcon, UserIcon} from "@components/icons/Icons";
import {FmvPrice} from "@components/fmv-price";
import {KeyIssueBadge} from "@components/key-issue-badge";

const MyCollectionListItemMobile = ({
    item,
    showEditMultiple,
    isSelected,
    toggleSelected,
    bookCover,
    onClick,
    issueDate,
    showPriceInfo,
    allowUnlimited,
    notes,
    navigate,
    postRemoveIssues,
    postCloneIssue,
    onSetBoxImage,
    boxId,
    removeIssueFromBox,
    getBoxName,
    showMarkAsSold,
    windowDimensions,
    showDollarGains,
}) => {

    return (
        <>
            <Row className="grid-list-item">

                {showEditMultiple && (
                    <Col span={1}  className="col-cbx">
                        {item.total_in_grade < 2 && (
                            <Checkbox
                                checked={isSelected}
                                onChange={() => toggleSelected(item.collection_item_id)}
                            />
                        )}
                    </Col>
                )}
                <Col className="width-135px">
                    <div className="col-image">
                        {bookCover}
                    </div>
                </Col>

                <Col className="grid-list-content-small-screen" >

                    <Row>
                        <Col span={12} className="flex-col" >
                            <div className="valueBadges">
                                {item.is_key && (<KeyIssueBadge keyInfo={item.key_info} windowDimensions={windowDimensions} isLargeScreen={false} biggerClass={true}/>)}
                                {item.is_hot && (<div className="valueBadge bigger hotIssue isActive"><FlameIcon /></div>)}
                                {item.is_rare && (<div className="valueBadge bigger rareIssue isActive"><DiamondIcon /></div>)}
                            </div>
                        </Col>
                        <Col span={12} className="item-actions" >
                            <div className="col-right">
                                {notes && (
                                    <Popover content={notes} trigger={["click"]}>
                                        <Button size={"small"} className="greyButton mar-left-5" >
                                            <FileTextOutlined className="icon12 iconDarkGrey" />
                                        </Button>
                                    </Popover>
                                )}

                                <Button type={"text"} className="greyButton mar-left-5" size={"small"} onClick={() => {
                                    if(onClick) onClick(item);
                                }} >
                                    <EditOutlined className="icon12 iconDarkGrey" />
                                </Button>

                                <Dropdown className="greyButton selectButton" trigger={["click"]} overlay={(
                                    <Menu >
                                        <Menu.Item key={1} onClick={() => showMarkAsSold()}>Mark as Sold</Menu.Item>
                                        <Menu.Item
                                            key={2}
                                            onClick={() => Modal.confirm({
                                                autoFocusButton: null,
                                                icon: <WarningOutlined />,
                                                content: (<div>
                                                    <div><b>Delete Items</b></div>
                                                    <div className="pad-top-10">
                                                        Are you sure?<br/>
                                                        Selecting this option will permanently delete these items.
                                                    </div>
                                                </div>),
                                                onOk() {
                                                    postRemoveIssues({issue_ids: [item.collection_item_id]});
                                                },
                                            })}
                                        >Delete</Menu.Item>
                                        <Menu.Item key={3} onClick={() => postCloneIssue({collection_item_id: item.collection_item_id})} >Duplicate</Menu.Item>
                                        {/*<Menu.Item key={4} disabled>List for Sale</Menu.Item>*/}
                                        {onSetBoxImage && (<Menu.Item key={5} onClick={() => {
                                            if(onSetBoxImage) onSetBoxImage(item.id)
                                        }} >Set as Box Image</Menu.Item>)}
                                        {boxId && (
                                            <Menu.Item key={7} onClick={() => removeIssueFromBox(boxId, item.collection_item_id)} >
                                                Remove from Virtual Box
                                            </Menu.Item>
                                        )}
                                        <Menu.Item key={6} ><a href={`/issue/${item.slug}`}>Go to Price Guide</a></Menu.Item>
                                    </Menu>
                                )}>
                                    <Button className="greyButton mar-left-5" size={"small"}>
                                        <EllipsisOutlined className="font-12 iconDarkGrey" />
                                    </Button>
                                </Dropdown>
                            </div>
                        </Col>
                    </Row>

                    <Row className="item-title" >
                        <Col span={24} className="flex-col">
                            <div className="break-spaces">
                                <div className="cursor-pointer titleLink font-16" onClick={() => {if(onClick) onClick(item); }}>{item.series_title}</div>
                                <div className="font-12 font-normal">
                                    {item.issue_number} - {item.is_variant ? item.variant_name : 'Regular'}
                                </div>
                                <div className="font-12 font-normal">
                                    {item.publisher} | {formatDateShort(issueDate)}
                                    {allowUnlimited ? (
                                        <>
                                            {item.box_ids && (
                                                <Dropdown className="greyButton selectButton float-right" trigger={["click"]} overlay={(
                                                    <Menu >
                                                        {item.box_ids.split(',').map((id,i) => (
                                                            <Menu.Item key={i} onClick={() => navigate('box-issues?view='+id)}>{getBoxName(id)}</Menu.Item>
                                                        ))}
                                                    </Menu>
                                                )}>
                                                    <Button className="greyButton mar-left-5" size={"small"}>
                                                        {item.box_ids.split(',').length}&nbsp;<StorageBoxOutlineIcon className="icon12 iconDarkGrey" />
                                                    </Button>
                                                </Dropdown>
                                            )}
                                        </>
                                    ):(
                                        <a className="upgrade-link float-right" href="/plans/unlimited/">Upgrade to use boxes</a>
                                    )}
                                </div>
                            </div>

                        </Col>
                    </Row>

                    <Row className="font-12">
                        <Col span={24}>
                            <div className={"graded-by rounded-row " + (item.graded_by.toUpperCase() === 'RAW' ? 'raw' : 'slab')}>
                                {item.graded_by ? item.graded_by.toUpperCase() : item.graded_or_raw.toUpperCase()} | {formatGrade(item.grade)}
                            </div>
                        </Col>
                    </Row>

                    <Row className="font-12">
                        <Col span={8} className={'flex-col flex-align-center fmv-col right-line ' + ((item.user_value > 0) ? 'user-fmv ' : '')}>
                            <span className="text-grey">Est. FMV</span>
                            {showPriceInfo ? (
                                <div className="flex-align-center">
                                    <FmvPrice
                                        prefix={
                                            (item.is_most_common_value && !(item.user_value > 0) && item.most_common_grade) ?
                                                ('('+formatGrade(item.most_common_grade)+') ') :
                                                null
                                        }
                                        value={item.value}
                                        stale={item.stale}
                                    />
                                    {(item.user_value > 0) && (
                                        <UserIcon className="grid-item-user-icon" />
                                    )}
                                </div>
                            ):(
                                <a className="upgrade-link" href="/plans/unlimited/">Upgrade to see values</a>
                            )}
                        </Col>
                        <Col span={8} className={'flex-col flex-align-center fmv-col right-line'}>
                            <span className="text-grey">Total Cost</span>
                            {formatMoney(item.total_comic_cost)}
                        </Col>
                        <Col span={8} className={'flex-col flex-align-center fmv-col '}>
                            <span className="text-grey">Gain / Loss</span>
                            {showPriceInfo ? (
                                    <div className={
                                        (item.user_profit ? (item.user_profit > 0 ? 'up ' : '')+(item.user_profit < 0 ? 'down ' : '') : '') +
                                        (item.stale ? ' stale' : '')
                                    } >
                                        {showDollarGains ? formatMoney(item.user_profit, true) : formatPercent(item.user_growth)}
                                    </div>
                            ) : (
                                <a className="upgrade-link" href="/plans/unlimited/">Upgrade to see values</a>
                            )}
                        </Col>
                    </Row>
                </Col>
            </Row>
        </>
    );

};

export default MyCollectionListItemMobile;